module.exports = "<pricings-page></pricings-page>\n";


//////////////////
// WEBPACK FOOTER
// ./src/views/appSettings/pricings.html
// module id = 1951
// module chunks = 0